import { Log } from '../AuxillaryService/Log';
import { isVideoHandlerInterface, Media } from '../MediaController';
import { assert } from '../Utility/assert';
import { isDevModeEnabled } from '../Utility/Environment';
import { EventEmitterEvent } from '../Utility/EventEmitter';
import { Widget } from '../Widget';
import { root } from './RootListeners';

const WIDGET_EVENTS = [
    'widget-initialize',
    'show-fullscreen-announcement',
    'hide-fullscreen-announcement',
];

const VIDEO_EVENTS = [Media.Ended];

export function initializeEventDebugging(): void {
    if (!isDevModeEnabled()) return;

    for (const eventName of WIDGET_EVENTS) {
        root.eventEmitter.addListener(eventName, (evt: EventEmitterEvent) => {
            assert(
                evt.targetObject instanceof Widget,
                'Widget events must have a `targetObject` that is an instance of `Widget`.'
            );
            Log.Debug(
                `Widget Event: ${eventName}:${evt.targetObject.type}:${evt.targetObject.name}`,
                null,
                __fileline,
                evt
            );
        });
    }

    for (const eventName of VIDEO_EVENTS) {
        root.eventEmitter.addListener(eventName, (evt: EventEmitterEvent) => {
            assert(
                isVideoHandlerInterface(evt.targetObject),
                'Video events must have a `targetObject` that is a Video Handler.'
            );
            Log.Debug(`Video Event: ${eventName}:${evt.targetObject.id}`, null, __fileline, evt);
        });
    }
}
